import React from 'react';
import {Col, Row} from 'antd';

import styles from './rules.module.scss';

const CharityEventRules: React.FC = (): JSX.Element => {
    return (
        <Row>
            <Col lg={24}>
                <h2 className={styles.rules_title}>Як взяти участь в акції «Стань Чарівником»</h2>
            </Col>
            <Col lg={12}>
                <div className={styles.rules}>
                    <div className={styles.number_rules}>01 - Обери дитячу мрію</div>
                    <p>
                        Переглянь список дітей, прочитай їхні листи до Святого Миколая та обери дитину, чиє бажання ти
                        хочеш здійснити.
                    </p>
                </div>
                <div className={styles.rules}>
                    <div className={styles.number_rules}>02 - Забронюй подарунок</div>
                    <p>
                        Натисни «Подарувати» та заповни коротку форму. Координатор зв'яжеться з тобою і підтвердить
                        бронювання.
                    </p>
                </div>
                <div className={styles.rules}>
                    <div className={styles.number_rules}>03 - Підготуй подарунок</div>
                    <p>
                        Придбай подарунок, про який дитина попросила у своєму листі, або замов його в інтернет-магазині.
                        За бажанням додай солодощі. Гарно запакуй усе у прозору упаковку або подарунковий пакет.
                    </p>
                    <p>
                        <strong>
                            Обов’язково вкажи прізвище, ім’я та номер обраної дитини на подарунку або в ТТН, щоб ми
                            могли передати його саме їй.
                        </strong>
                    </p>
                </div>
                <div className={styles.rules}>
                    <div className={styles.number_rules}>04 - Надішли подарунок з 1 листопада до 1 грудня</div>
                    <p>
                        Надішли подарунок у прозорій упаковці або подарунковому пакеті, вказавши на ньому прізвище, ім’я
                        та номер обраної дитини.
                    </p>
                    <p className={styles.rules_important}>
                        Якщо твої обставини змінилися і ти не можеш підготувати подарунок, будь ласка, одразу повідом
                        координатора. Так ми встигнемо знайти іншого Чарівника, який допоможе здійснити мрію дитини.
                    </p>
                </div>
                <div className={styles.rules}>
                    <div className={styles.number_rules}>05 - Дивись, як мрії стають реальністю</div>
                    <p>
                        Після 19 грудня ми поступово публікуватимемо фотозвіти про передані подарунки. Переглянути звіт
                        про подарунок для обраної дитини можна за кнопкою «Звіт» або в розділі «Втілені мрії».
                    </p>
                </div>
            </Col>
            <Col lg={12}>
                <div className={styles.rules_send}>
                    <div className={styles.rules_send_item}>
                        <div className={styles.rules_send__title}>Адреса для відправлення подарунку</div>
                        <div className={styles.rules_address}>
                            <span className={styles.rules_address__title}>Адреса:</span>
                            <div>
                                м. Миколаїв, Нова Пошта, відділення №6
                                <p style={{margin: '5px 0'}}>
                                    м. Миколаїв, Нова Пошта, відділення № 2 (для великогабаритних подарунків)
                                </p>
                            </div>
                        </div>
                        <div className={styles.rules_address}>
                            <span className={styles.rules_address__title}>Отримувач:</span>
                            <span>Ткаченко Валентина</span>
                        </div>
                        <div className={styles.rules_address}>
                            <span className={styles.rules_address__title}>Телефон:</span>
                            <span>+38 (097) 239 72 70</span>
                        </div>
                    </div>
                    <div className={styles.important}>
                        <h3>Важливо!</h3>
                        <p>
                            Оплати доставку посилки. Обов’язково вкажи прізвище, ім’я та номер обраної дитини, щоб ми
                            могли передати подарунок саме їй. Якщо замовляєш подарунок онлайн, не забудь зазначити ці
                            дані в ТТН.
                        </p>
                    </div>
                    <div className={styles.rules_send_item}>
                        <div className={styles.rules_send__title}>Не можеш передати подарунок?</div>
                        <p>Ти все одно можеш стати частиною дива.</p>
                        <p>
                            Щороку не всі діти знаходять свого Чарівника. Ти можеш підтримати акцію фінансово будь-якою
                            зручною сумою. Кошти допоможуть придбати подарунки та солодощі для дітей, які залишилися без
                            Чарівника.
                        </p>
                    </div>
                    <div className={styles.rules_send_item}>
                        <div className={styles.rules_send__details}>Реквізити для підтримки:</div>
                        <ul>
                            <li>ПриватБанк: 4731 2196 5269 9574</li>
                            <li>MonoBank: 4441 1111 6323 3616</li>
                        </ul>
                        <p>Отримувач: Ткаченко Валентина Валентинівна</p>
                    </div>
                </div>
            </Col>
        </Row>
    );
};
export default CharityEventRules;
